module.exports = __webpack_public_path__ + "img/footer.721c7a9f.jpg";